<div class="container-message-error">
    <div *ngIf="arrowOrientation === 'up'" class="arrow-up"></div>
    <p class="message-error">{{ message }}</p>
    <div *ngIf="arrowOrientation === 'down'" class="arrow-down"></div>
</div>
